import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import closeIcon from "../../assets/img/icons/closeIcon.svg";
import { useSiteData } from "../../SiteDataContext";

const MobileMenu: React.FC = () => {
  const { siteData, setSiteData } = useSiteData();

  const close = (): void => {
    setSiteData({ ...siteData, isOpenMobileMenuModal: false });
  };

  const handleBackgroundClick = (e: React.MouseEvent<HTMLDivElement>): void => {
    if ((e.target as HTMLElement).id === "mobile-menu") {
      close();
    }
  };

  const { t } = useTranslation();

  return (
    <div
      id="mobile-menu"
      role="dialog"
      aria-label="Mobile menu"
      className={`modal-container p-0 flex justify-start items-center ${
        siteData.isOpenMobileMenuModal ? "" : "hidden"
      }`}
      onClick={handleBackgroundClick}
    >
      <div className="overflow-auto relative w-[70%] h-full bg-cream p-8">
        <div
          role="button"
          aria-label="Close"
          className="inline absolute right-4 top-4 p-0-5 cursor-pointer"
          onClick={close}
        >
          <img className="w-1-125" src={closeIcon} alt="" />
        </div>

        <article className="f-size-1 mt-4">
          <div className="flex justify-center mb-2">
            <Link
              to="/about"
              onClick={close}
              className="text-center w-16-25 md:w-21-25 br-0-5 main-button bg-dark-green f-size-1-125 md:f-size-1-5 md:lt-0-02"
            >
              {t("header.about")}
            </Link>
          </div>
          {siteData.show_dns_monitor === true && (
            <div className="flex justify-center mb-2">
              <Link
                to="/dns-monitor"
                onClick={close}
                className="text-center w-16-25 md:w-21-25 br-0-5 main-button bg-dark-green f-size-1-125 md:f-size-1-5 md:lt-0-02"
              >
                {t("header.dns_monitor")}
              </Link>
            </div>
          )}
          {siteData.show_statistics === true && (
            <div className="flex justify-center mb-2">
              <Link
                to="/stat"
                onClick={close}
                className="text-center w-16-25 md:w-21-25 br-0-5 main-button bg-dark-green f-size-1-125 md:f-size-1-5 md:lt-0-02"
              >
                {t("header.stat")}
              </Link>
            </div>
          )}
          <div className="flex justify-center mb-2">
            <Link
              to="/contacts"
              onClick={close}
              className="text-center w-16-25 md:w-21-25 br-0-5 main-button bg-dark-green f-size-1-125 md:f-size-1-5 md:lt-0-02"
            >
              {t("header.contacts")}
            </Link>
          </div>
        </article>
      </div>
    </div>
  );
};

export default MobileMenu;
